const MUSIC_IMAGE_HOSTS = new Set(['musics3.styletpff.com', 's3.styletpff.com']);

/** The configured generation placeholder, including its known CDN transforms. */
export function isDefaultMusicCover(src: unknown): boolean {
  if (typeof src !== 'string' || !src.trim()) return false;
  try {
    const url = new URL(src);
    if (url.protocol !== 'https:' || !MUSIC_IMAGE_HOSTS.has(url.hostname) || url.port || url.username || url.password) return false;
    return url.pathname.replace(/^\/cdn-cgi\/image\/[^/]+\//, '/') === '/common/music_default.jpg';
  } catch {
    return false;
  }
}

// Resize only our public image CDN. Signed URLs and other providers must keep
// their original path/query; rewriting those can invalidate authorization.
export function musicCoverUrl(src: string, size: number): string {
  try {
    const url = new URL(src);
    if (url.protocol !== 'https:' || !MUSIC_IMAGE_HOSTS.has(url.hostname) || url.search || url.username || url.password || !Number.isInteger(size) || size <= 0) return src;
    const path = url.pathname.replace(/^\/cdn-cgi\/image\/[^/]+\//, '/');
    url.pathname = `/cdn-cgi/image/width=${size},height=${size},fit=cover,quality=80,format=webp${path}`;
    return url.href;
  } catch {
    return src;
  }
}

export function musicCoverSrcset(src: string, sizes: number[]): string | undefined {
  if (!sizes.length || musicCoverUrl(src, sizes[0]) === src) return undefined;
  return sizes.map(size => `${musicCoverUrl(src, size)} ${size}w`).join(', ');
}
